import React from 'react';
import { useNavigate } from 'react-router-dom';

const CARDS = [
  {
    path:        '/control-panel/supplier-automation',
    icon:        '⚙️',
    title:       'Supplier Automation',
    description: 'Turn Smart Buyer and Auto Stock Refresh on or off per supplier.',
    accent:      'blue',
  },
  {
    path:        '/control-panel/next-actions',
    icon:        '📋',
    title:       'Blocked Order — Next Actions',
    description: 'Manage the "Next Action" dropdown options on Blocked Orders / Follow-Up Schedule.',
    accent:      'gold',
  },
  {
    path:        '/control-panel/blacklist',
    icon:        '🚫',
    title:       'Customer Blacklist',
    description: 'Manage customers whose new orders get auto-flagged as Problem Encountered.',
    accent:      'red',
  },
  {
    path:        '/control-panel/brand-exclusion',
    icon:        '🏷️',
    title:       'Brand Exclusion',
    description: 'Manage brands excluded from a supplier\'s restock calculator output.',
    accent:      'gold',
  },
];

const ControlPanel = () => {
  const navigate = useNavigate();

  return (
    <main className="app-main">
      <div className="page-nav">
        <button className="back-btn" onClick={() => navigate('/')}>← Home</button>
        <span className="page-nav__title">Control Panel</span>
      </div>

      <div className="home-greeting">
        <p className="home-greeting__sub">Select a function to get started</p>
      </div>
      <div className="home-cards">
        {CARDS.map((card) => (
          <button
            key={card.path}
            className={`home-card home-card--${card.accent}`}
            onClick={() => navigate(card.path)}
          >
            <div className="home-card__icon">{card.icon}</div>
            <div className="home-card__body">
              <div className="home-card__title">{card.title}</div>
              <div className="home-card__desc">{card.description}</div>
            </div>
            <div className="home-card__arrow">→</div>
          </button>
        ))}
      </div>
    </main>
  );
};

export default ControlPanel;
